import React from "react"
import PropTypes from "prop-types"
import "./device.scss"
import Button from "../shared/button/text-button"
import star from "../../images/icons/star.png"

const Device = ({
  id,
  onClick,
  //type,
  name,
  rating,
  availableColors,
  details,
  costText,
  image,
  excludeVAT
}) => {
  const handleClick = () => onClick(id)

  return (
    <li className="device">
      <div className="imageContainer">
        <img onClick={handleClick} src={image} alt={name} />
      </div>
      <div className="title">{name}</div>

      <div className="device--details">
        {details && (
          <ul className="device--details">
            <li>{details.storage} storage</li>
            <li>{details.screensize} screen</li>
            <li>{details.battery} battery life</li>
          </ul>
        )}
      </div>

      <div className="costInfo">
        <div className="cost">{costText}</div>
        {excludeVAT ? <div className="vatDescription">(exc. VAT)</div> : ""}
      </div>
      <div className="color-rating-container--block">
        {availableColors && (
          <div className="color-container--block">
            {availableColors.map(number => (
              <div style={{ "background-color": number }} key={number} />
            ))}
          </div>
        )}
        <div className="rating">
          {Array(rating || 0).fill(<img src={star} alt="" />)}
        </div>
      </div>
      <div className="device--button-container">
        <Button onClick={handleClick} text={`Select`} />
      </div>
    </li>
  )
}

Device.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  rating: PropTypes.number,
  availableColors: PropTypes.string,
  details: PropTypes.object,
  costText: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  excludeVAT: PropTypes.bool
}

Device.defaultProps = {
  excludeVAT: false
}

export default Device
